class SimpleDispatcher{
    constructor(){}
    static registry = {}
    static on(key, callback){
        this.registry[key] = callback
    }
    static dispatch(key, ...args){
        const event = new Event('DispatcherEvent');
        event.args = args
        const callback = this.registry?.[key]
        if(callback){
            callback(event)
        }   
    }
}

class Dispatcher{
    static instances = {}
    static registerByKey(id, instance){
        if(!Object.keys(this.instances).includes(id)){
            this.instances[id] = []
        }
        this.instances[id].push(instance)
    }
    static dispatchByKey(id, event_name, args){
        for(const instance of this.instances[id]){
            instance.dispatchEvent(event_name, args)
        }
    }
}

export {
    SimpleDispatcher,
    Dispatcher
}